/** Virtual POS category id — not stored in categories table */
export const OFFERS_CATEGORY_ID = '__offers__';

/**
 * Product units reserved across all open carts (standalone products + offer components).
 */
export function getCartProductDemand(orders, options = {}) {
  const { excludeItemId = null, excludeOrderId = null } = options;
  const demand = {};
  for (const order of orders || []) {
    if (excludeOrderId && order.id === excludeOrderId) continue;
    for (const item of order.cart || []) {
      if (excludeItemId && item.id === excludeItemId) continue;
      if (item.type === 'offer' && item.components) {
        for (const comp of item.components) {
          const pid = comp.product_id;
          const perBundle = parseFloat(comp.quantity) || 0;
          demand[pid] = (demand[pid] || 0) + (parseFloat(item.quantity) || 0) * perBundle;
        }
      } else {
        demand[item.id] = (demand[item.id] || 0) + (parseFloat(item.quantity) || 0);
      }
    }
  }
  return demand;
}

/** How many complete offer bundles can be sold given stock and cart demand. */
export function bundlesAvailableForOffer(offer, productStockById, cartDemandByProduct) {
  const items = offer?.items || offer?.components || [];
  if (!items.length) return 0;
  let min = Infinity;
  for (const comp of items) {
    const pid = comp.product_id;
    const perBundle = parseFloat(comp.quantity) || 0;
    if (perBundle <= 0) return 0;
    const stock = parseFloat(productStockById[pid] ?? 0);
    const reserved = parseFloat(cartDemandByProduct[pid] ?? 0);
    const available = Math.max(0, stock - reserved);
    const bundles = Math.floor(available / perBundle);
    min = Math.min(min, bundles);
  }
  return min === Infinity ? 0 : min;
}

export function mapOfferForPos(offer) {
  return {
    id: offer.id,
    type: 'offer',
    name: offer.name,
    sku: offer.sku || null,
    price: parseFloat(offer.selling_price) || 0,
    selling_price: parseFloat(offer.selling_price) || 0,
    image_url: offer.image_path,
    image_path: offer.image_path,
    is_active: offer.is_active !== false,
    preview_cost: parseFloat(offer.preview_cost) || 0,
    components: (offer.items || []).map((it) => ({
      product_id: it.product_id,
      product_name: it.product_name,
      quantity: parseFloat(it.quantity) || 0,
      unit_type: it.unit_type === 'kg' ? 'weight' : it.unit_type || 'piece',
    })),
    items: offer.items,
  };
}
